import {
    effect,
    Component,
    OnInit,
    ViewChild,
    ElementRef,
    WritableSignal,
    signal,
    ChangeDetectorRef
} from '@angular/core';
import { DatePickerModule } from 'primeng/datepicker';
import {
    FormsModule,
    ReactiveFormsModule,
    FormBuilder,
    FormGroup,
    FormControl
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import {
    faArrowRightToBracket,
    faArrowRightFromBracket,
    faTrash
} from '@fortawesome/free-solid-svg-icons';
import { formatDate } from '@angular/common';
import { MatDateRangePicker } from '@angular/material/datepicker';
import { timeout } from 'rxjs';
import { HistogramaComponent } from '../../../../shared/components/histograma/histograma/histograma.component';
import {
    TableRow,
    TableColumn
} from '../../../../shared/models/components/tables/table.models';
import { StrategyRules } from '../../../../shared/models/store/strategyRules.model';
import { InputsTableComponent } from '../model-predictions/inputs-table/inputs-table.component';
import { MatButtonModule } from '@angular/material/button';
import { ResultsTableComponent } from '../model-predictions/results-table/results-table.component';
import { SharedDataService } from '../../../../shared/services/shared-data.service';
import { DividerModule } from 'primeng/divider';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import {
    DateRange,
    TradingStrategyReqModel
} from '../../../../shared/models/serviceModels/request/tradingStrategyReq.model';
import { faChartLine } from '@fortawesome/free-solid-svg-icons';
import { TradingStrategyService } from '../../../../shared/services/componentsServices/tradingStrategy.service';
import { LoadingButtonComponent } from '../../../../shared/components/loading-button/loading-button.component';
import { StrategyRule } from '../../../../shared/models/serviceModels/request/tradingStrategyReq.model';
import { StrategyRuleName } from '../../../../shared/enums/strategy-rule-name.enum';
import {
    tradingStrategyResponse,
    tradingStrategyMetrics,
    tradingStrategyRecord
} from '../../../../shared/models/serviceModels/response/trading-strategy-response.model';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { NotificationPopupComponent } from '../../../../shared/components/notification-popup/notification-popup.component';

@Component({
    selector: 'app-trading-strategy',
    imports: [
        LoadingButtonComponent,
        NotificationPopupComponent,
        DatePickerModule,
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        FontAwesomeModule,
        MatDatepickerModule,
        MatFormFieldModule,
        MatInputModule,
        MatNativeDateModule,
        // MatDateRangePicker,
        HistogramaComponent,
        // InputsTableComponent,
        MatButtonModule,
        ResultsTableComponent,
        DividerModule
    ],
    templateUrl: './trading-strategy.component.html',
    styleUrls: ['./trading-strategy.component.scss']
})
export class TradingStrategyComponent implements OnInit {
    @ViewChild('startInput') startInput!: ElementRef;
    @ViewChild('endInput') endInput!: ElementRef;
    @ViewChild('dateRangePicker') dateRangePicker!: MatDateRangePicker<any>;

    faXmark = faXmark;
    faChartLine = faChartLine;
    faSpinner = faSpinner;

    selectedDates: Date[] | null = null;
    excludedDates: Date[] = [];
    faArrowRightToBracket = faArrowRightToBracket;
    faArrowRightFromBracket = faArrowRightFromBracket;
    faTrash = faTrash;
    testDate: Date | null = null;
    baseScenario: WritableSignal<TableColumn | null> = signal(null);

    selectedStrategy: string = '';

    //optional strategy fields
    exitDifferencePercentage: string = '';
    exitDifferenceValue: string = '';

    //mandatory strategy fields
    differencePercentage: string = '';
    differenceValue: string = '';
    stopLossPercentage: string = '';
    stopLossValue: string = '';
    takeProfitPercentage: string = '';
    takeProfitValue: string = '';

    range: FormGroup;
    exclusionDateRanges: DateRange[] = [];
    columnsAllTradesCopy: TableRow[] = [];

    rangeDates: Date[] | null = null;
    predictionRange: Date[] | null = null;
    isButtonDisabled: boolean = true;
    isVisible = false;
    isResultVisible = signal(false);
    isRequiredByModel = signal(false);
    isSpinnerVissible = signal(false);

    hasTestPeriod = signal(false);

    columnsSummary: WritableSignal<TableColumn[]> = signal([]);

    rowsSummary: WritableSignal<TableRow[]> = signal([]);
    columnsAllTrades: WritableSignal<TableColumn[]> = signal([]);

    rowsAllTrades: WritableSignal<TableRow[]> = signal([]);

    isNotificationPopupOpen = signal(false);
    errorMessage: WritableSignal<string> = signal('');
    secondErrorMessage: WritableSignal<string> = signal('');

    constructor(
        private fb: FormBuilder,
        private SharedDataService: SharedDataService,
        private TradingStrategyService: TradingStrategyService,
        private cd: ChangeDetectorRef
    ) {
        this.range = this.fb.group({
            start: [null],
            end: [null]
        });

        this.SharedDataService.setRowsSummary(this.rowsSummary());

        this.columnsAllTradesCopy = [...this.rowsAllTrades()];

        this.rowsAllTrades = this.SharedDataService.getRowsAllTrades();
    }

    ngOnInit(): void {
        this.range.valueChanges.subscribe((value) => {
            if (value.start && value.end) {
                this.exclusionDateRanges.push({
                    start: value.start,
                    end: value.end
                });
                this.range.reset();
            }
        });

        this.setCachedDataInUi();
    }

    closeNotificationPopup() {
        this.isNotificationPopupOpen.set(false);
    }

    setCachedDataInUi() {
        this.getCachedRules();
        this.setRunDateRange();
        this.exclusionDateRanges =
            this.TradingStrategyService.getExclusionDateRanges();

        let currentStrategy =
            this.TradingStrategyService.getBackupTradingStrategyResponse();

        if (currentStrategy !== null && currentStrategy !== undefined) {
            this.setSummaryInUI(currentStrategy.metrics);

            this.isResultVisible.set(true);

            this.setCachedRecordsInUi(currentStrategy);
        }
    }

    setCachedRecordsInUi(currentStrategy: tradingStrategyResponse) {
        let cachedRows = this.SharedDataService.getRowsAllTrades();

        if (cachedRows() && cachedRows().length > 0) {
            this.setFilteredCachedRecordsInUi(
                currentStrategy.records,
                cachedRows()
            );

            return;
        }

        this.setRecordsInUi(currentStrategy.records);
    }

    setFilteredCachedRecordsInUi(
        data: tradingStrategyRecord[],
        filteredRows: TableRow[]
    ) {
        let recordsColumns: TableColumn[] = this.setRecordsTableColumns(data);
        this.columnsAllTrades.set(recordsColumns);

        this.rowsAllTrades.set(filteredRows);
    }

    setRunDateRange() {
        const savedRange =
            this.TradingStrategyService.getCurrentPredictionRange();
        const validRange = this.normalizeDateRange(savedRange);
        if (validRange) {
            this.predictionRange = [
                new Date(validRange[0]),
                new Date(validRange[1])
            ];
            this.cd.detectChanges();
            this.hasTestPeriod.set(true);
            this.isButtonDisabled = false;
        }
    }

    onRunRangeChange(event: any) {
        const validRange = this.normalizeDateRange(this.predictionRange);

        if (!validRange) {
            return;
        }

        this.predictionRange = [new Date(validRange[0]), new Date(validRange[1])];
        this.isButtonDisabled = false;
        this.hasTestPeriod.set(true);
        this.TradingStrategyService.setCurrentPredictionRange([
            new Date(validRange[0]),
            new Date(validRange[1])
        ]);
    }

    formatRange(start: Date | null | undefined, end: Date | null | undefined): string {
        if (!(start instanceof Date) || isNaN(start.getTime())) {
            return '';
        }

        if (!(end instanceof Date) || isNaN(end.getTime())) {
            return '';
        }

        return `${formatDate(start, 'MMMM d, yyyy', 'en-US')} - ${formatDate(
            end,
            'MMMM d, yyyy',
            'en-US'
        )}`;
    }

    removeRange(index: number): void {
        this.exclusionDateRanges.splice(index, 1);
    }

    onCancelClick(
        startInput: HTMLInputElement,
        endInput: HTMLInputElement
    ): void {
        startInput.value = '';
        endInput.value = '';
    }

    onStrategyChange(strategy: string) {
        this.selectedStrategy = strategy;
    }

    // clearValue(type: string) {
    //   if (type === 'exitDifferencePercentage' || type === 'exitDifferenceValue') {
    //     this.exitDifferencePercentage = type === 'exitDifferencePercentage' ? this.exitDifferencePercentage : '';
    //     this.exitDifferenceValue = type === 'exitDifferenceValue' ? this.exitDifferenceValue : '';
    //   } else if (type === 'stopLossPercentage' || type === 'stopLossValue') {
    //     this.stopLossPercentage = type === 'stopLossPercentage' ? this.stopLossPercentage : '';
    //     this.stopLossValue = type === 'stopLossValue' ? this.stopLossValue : '';
    //   } else if (type === 'takeProfitPercentage' || type === 'takeProfitValue') {
    //     this.takeProfitPercentage = type === 'takeProfitPercentage' ? this.takeProfitPercentage : '';
    //     this.takeProfitValue = type === 'takeProfitValue' ? this.takeProfitValue : '';
    //   }else if (type === 'percentage') {
    //     this.differenceValue = '';
    //   } else if (type === 'value') {
    //     this.differencePercentage = '';
    //   }

    //   this.storeCachedRules();
    // }

    storeCachedRules() {
        const strategyRules: StrategyRules = {
            entryDifferencePercentage: this.differencePercentage,
            entryDifferenceValue: this.differenceValue,
            exitDifferencePercentage: this.exitDifferencePercentage,
            exitDifferenceValue: this.exitDifferenceValue,
            stopLossPercentage: this.stopLossPercentage,
            stopLossValue: this.stopLossValue,
            takeProfitPercentage: this.takeProfitPercentage,
            takeProfitValue: this.takeProfitValue
        };

        this.SharedDataService.setStrategyRules(strategyRules);
    }

    reset(): void {
        let fullRows = this.SharedDataService.getOriginalRowsAllTrades();

        this.SharedDataService.setRowsAllTrades(fullRows);
        // this.SharedDataService.setRowsAllTrades(this.columnsAllTradesCopy);
    }

    getCachedRules(): StrategyRules {
        const cachedRules = this.SharedDataService.getStrategyRules();
        this.differencePercentage = cachedRules.entryDifferencePercentage;
        this.differenceValue = cachedRules.entryDifferenceValue;
        this.exitDifferencePercentage = cachedRules.exitDifferencePercentage;
        this.exitDifferenceValue = cachedRules.exitDifferenceValue;
        this.stopLossPercentage = cachedRules.stopLossPercentage;
        this.stopLossValue = cachedRules.stopLossValue;
        this.takeProfitPercentage = cachedRules.takeProfitPercentage;
        this.takeProfitValue = cachedRules.takeProfitValue;

        return cachedRules;
    }

    onDateRangeChange(event: any) {
        const validRange = this.normalizeDateRange(this.rangeDates);

        if (!validRange || this.exclusionDateRanges.length === 5) {
            return;
        }

        const [startDate, endDate] = validRange;

        let isInRange = this.isWithinRange(
            new Date(startDate),
            new Date(endDate)
        );

        if (isInRange) {
            return;
        }

        this.exclusionDateRanges.push({
            start: new Date(startDate),
            end: new Date(endDate)
        });

        this.rangeDates = null;
    }

    isWithinRange(start: Date, end: Date): boolean {
        for (const range of this.exclusionDateRanges) {
            if (start >= range.start && end <= range.end) {
                return true;
            }
        }
        return false;
    }

    isNullOrEmpty(value: any): boolean {
        return value === null || value === undefined || value === '';
    }

    isRunButtonDisabled() {
        let hasEntryStrategy =
            !this.isNullOrEmpty(this.differencePercentage) ||
            !this.isNullOrEmpty(this.differenceValue);

        let hasExitStopLossStrategy =
            !this.isNullOrEmpty(this.stopLossPercentage) ||
            !this.isNullOrEmpty(this.stopLossValue);
        let hasExitTakeProfitStrategy =
            !this.isNullOrEmpty(this.takeProfitPercentage) ||
            !this.isNullOrEmpty(this.takeProfitValue);

        let response =
            hasEntryStrategy &&
            hasExitStopLossStrategy &&
            hasExitTakeProfitStrategy &&
            this.hasTestPeriod();

        return !response;
    }

    getExcludedDates(): DateRange[] {
        const excludedDates: DateRange[] = [];

        this.exclusionDateRanges.forEach((range) => {
            const startDate = new Date(range.start);
            const endDate = new Date(range.end);

            excludedDates.push({
                start: startDate,
                end: endDate
            });
        });

        return excludedDates;
    }

    getServiceRequest(): TradingStrategyReqModel {
        const excludedDates: DateRange[] = this.getExcludedDates();
        const validRange = this.normalizeDateRange(this.predictionRange);

        const strategyRules: StrategyRule[] = [
            {
                ruleName: StrategyRuleName.EntryThresholdPercentage,
                ruleValue: this.differencePercentage?.toString()
            },
            {
                ruleName: StrategyRuleName.EntryThresholdAbsolute,
                ruleValue: this.differenceValue?.toString()
            },
            {
                ruleName: StrategyRuleName.StopLossThresholdPercentage,
                ruleValue: this.stopLossPercentage?.toString()
            },
            {
                ruleName: StrategyRuleName.StopLossThresholdAbsolute,
                ruleValue: this.stopLossValue?.toString()
            },
            {
                ruleName: StrategyRuleName.ProfitTakingThresholdPercentage,
                ruleValue: this.takeProfitPercentage?.toString()
            },
            {
                ruleName: StrategyRuleName.ProfitTakingThresholdAbsolute,
                ruleValue: this.takeProfitValue?.toString()
            }
        ];

        // const startDate = this.dateRanges.length > 0 ? this.dateRanges[0].start : null;
        // const endDate = this.dateRanges.length > 0 ? this.dateRanges[this.dateRanges.length - 1].end : null;

        const startDate = validRange ? validRange[0] : null;
        const endDate = validRange ? validRange[1] : null;

        const tradingStrategyInputs: TradingStrategyReqModel = {
            strategyRules: strategyRules,
            startDate: startDate ? new Date(startDate) : new Date(),
            endDate: endDate ? new Date(endDate) : new Date(),
            excludedDates: excludedDates.length > 0 ? excludedDates : []
        };
        return tradingStrategyInputs;
    }

    private normalizeDateRange(range: Date[] | (Date | null | undefined)[] | null | undefined): [Date, Date] | null {
        if (!Array.isArray(range) || range.length < 2) {
            return null;
        }

        const start = range[0];
        const end = range[1];

        if (!(start instanceof Date) || isNaN(start.getTime())) {
            return null;
        }

        if (!(end instanceof Date) || isNaN(end.getTime())) {
            return null;
        }

        return [start, end];
    }

    runStrategy() {
        let currentRequest = this.getServiceRequest();
        this.isSpinnerVissible.set(true);
        this.TradingStrategyService.runTradingStrategy(currentRequest)
            .pipe(timeout(30000))
            .subscribe({
                next: (data) => {
                    this.isSpinnerVissible.set(false);

                    if (data.errorMsg !== null && data.errorMsg !== '') {
                        this.isResultVisible.set(false);
                        this.handleErrorMessage(
                            data.errorMsg,
                            'Please check the inputs and try again.'
                        );

                        return;
                    }
                    this.TradingStrategyService.setBackupTradingStrategyResponse(
                        data
                    );
                    this.setTradingStrategyInUi(data);

                    this.isResultVisible.set(true);
                },
                error: (err) => {
                    this.isSpinnerVissible.set(false);
                    this.isResultVisible.set(false);
                    this.handleErrorMessage(
                        err,
                        'Please check the inputs and try again.'
                    );
                }
            });
    }

    handleErrorMessage(errorMessage: string, secondErrorMessage: string = '') {
        let errorMsg = `An error occurred while running the model: ${errorMessage}`;
        this.errorMessage.set(errorMsg);
        this.secondErrorMessage.set(secondErrorMessage);
        this.isNotificationPopupOpen.set(true);
    }

    setTradingStrategyInUi(data: tradingStrategyResponse) {
        this.setSummaryInUI(data.metrics);
        this.setRecordsInUi(data.records);
    }

    setSummaryInUI(summaryData: tradingStrategyMetrics) {
        let summaryColumns: TableColumn[] =
            this.setSummaryTableColumns(summaryData);
        this.columnsSummary.set(summaryColumns);

        let summaryRows: TableRow[] = this.setTablesRows(summaryData);
        this.rowsSummary.set(summaryRows);
    }

    setTablesRows(
        data: tradingStrategyMetrics | tradingStrategyRecord[]
    ): TableRow[] {
        if (Array.isArray(data) && data.length === 0) {
            return [];
        }

        let currentData = Array.isArray(data) ? data : [data];

        return currentData.map((item, index) => {
            const row: TableRow = {
                field: (index + 1).toString(),
                inputId: null
            };

            Object.entries(item).forEach(([key, value]) => {
                if (typeof value === 'string') {
                    row[key] = isNaN(Date.parse(value))
                        ? value.replace(/_/g, ' ')
                        : new Date(value);
                } else if (typeof value === 'number') {
                    row[key] = value;
                } else {
                    row[key] = value;
                }
            });

            return row;
        });
    }

    setSummaryTableColumns(data: tradingStrategyMetrics): TableColumn[] {
        let columns: TableColumn[] = [];
        columns = this.setTableColumns([data]);
        return columns;
    }

    setTableColumns<T extends tradingStrategyMetrics | tradingStrategyRecord>(
        data: T[]
    ): TableColumn[] {
        if (data.length === 0) {
            return [];
        }

        const sampleItem = data[0];
        return Object.keys(sampleItem).map((key) => ({
            header: this.formatString(key),
            field: key,
            name: this.formatString(key),
            editable: false,
            deletable: false,
            isFrozen: false
        }));
    }

    formatString(key: string): string {
        return key
            .replace(/([A-Z])/g, ' $1')
            .replace(/^./, (str) => str.toUpperCase());
    }

    setRecordsInUi(data: tradingStrategyRecord[]) {
        let recordsColumns: TableColumn[] = this.setRecordsTableColumns(data);
        this.columnsAllTrades.set(recordsColumns);

        let recordsRows: TableRow[] = this.setTablesRows(data);
        this.rowsAllTrades.set(recordsRows);
        this.SharedDataService.setOriginalRowsAllTrades(recordsRows);
        this.SharedDataService.setRowsAllTrades(this.rowsAllTrades());
        this.columnsAllTradesCopy = [...this.rowsAllTrades()];
    }

    setRecordsTableColumns(data: tradingStrategyRecord[]): TableColumn[] {
        let columns: TableColumn[] = [];
        columns = this.setTableColumns(data);
        return columns;
    }
}
